/** @jsxImportSource theme-ui */

import React from 'react';
import { getVariant } from '../utils';

export const VARIANT = {
    primary: 'primary',
    secondary: 'secondary',
    alternate: 'alternate',
} as const;

interface ButtonStyleProps {
    variant?: keyof typeof VARIANT;
    isLoading?: boolean;
}

export interface ButtonProps extends ButtonStyleProps, Omit<React.HTMLAttributes<HTMLButtonElement>, 'css'> {}

export function Button({ children, variant, isLoading, ...otherProps }: ButtonProps): JSX.Element {
    return (
        <button
            sx={{ variant: getVariant({ stylePath: 'buttons', variant: isLoading ? `${variant}-loading` : variant }) }}
            {...otherProps}
        >
            {children}
        </button>
    );
}

Button.defaultProps = {
    variant: 'primary',
    isLoading: false,
    disabled: false,
    type: 'button',
};
